import Cookies from 'js-cookie';

export const simplifyJson = (json, key) => {
  let data = !key ? json : json[key];
  if (key === "errors") {
    let errorMap = {};
    if (Array.isArray(data)) {
      errorMap = data.reduce((ov, nv) => {
        ov[nv.id] = nv.msg;
        return ov;
      }, {});
    } else if (typeof data === "object") {
      errorMap[data.id] = data.msg;
    }
    json[key] = errorMap;
  } else if (typeof data === "object") {
    for (let k in data) {
      simplifyJson(data, k);
    }
  }
};

export const clickHandler = (savedChannelCode) =>  {
      var cookieTimeLimit = 5;
      var CookieData = savedChannelCode;
      var expireTime = new Date().setTime(new Date().getTime() + (cookieTimeLimit * 60 * 1000));
      Cookies.set('lg_partner_lead', CookieData, { expires: expireTime, secure: true });
   }

export const isGemidsNull = (gemId1 , gemId2) => {
      if(!gemId1 || !gemId2 || gemId1 === null || gemId2===null){
         return true;
      }else{
         return false;
      }
   }